import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "chat-buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AiButton = _resolveComponent("AiButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (item, idx) => {
      return (_openBlock(), _createBlock(_component_AiButton, {
        key: idx,
        type: item.type,
        title: item.title,
        selected: $options.selected == idx,
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        onClick: $event => ($options.onSelected(idx, item))
      }, null, 8 /* PROPS */, ["type", "title", "selected", "onClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}